'use client';

import { clsx } from 'clsx';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'glass' | 'solid' | 'elevated';
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingMap = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export function Card({
  className,
  variant = 'glass',
  hover = true,
  padding = 'md',
  children,
  ...props
}: CardProps) {
  const base =
    'rounded-[12px] border transition-all duration-200 ' +
    (variant === 'glass'
      ? 'glass-card'
      : variant === 'solid'
        ? 'bg-bg border-nature-border'
        : 'bg-bg border-nature-border shadow-md');
  const hoverClass = hover ? 'card-hover' : '';

  return (
    <div
      className={clsx(base, hoverClass, paddingMap[padding], className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx('mb-3 font-display font-semibold text-nature-text relative', className)} {...props}>
      {/* Subtle logo branding */}
      <img
        src="/logo-eh.png"
        alt=""
        className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-auto opacity-10 pointer-events-none select-none"
        aria-hidden="true"
      />
      {props.children}
    </div>
  );
}

export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={clsx('text-base font-display font-semibold text-nature-text', className)}
      {...props}
    />
  );
}

export function CardContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('text-nature-muted text-sm', className)} {...props} />;
}

export function CardFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx('flex items-center p-6 pt-0', className)}
      {...props}
    />
  );
}
